import ApiGateway from '../api.gateway';

const ShippingService = {
  list: async function (records, page, search) {
    try {
      const response = await ApiGateway.get(`/gateway/shipping?records=${records}&page=${page}&search=${search}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  findById: async function (id) {
    try {
      const response = await ApiGateway.get(`/gateway/shipping/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  create: async function (data) {
    try {
      const response = await ApiGateway.post(`/gateway/shipping/`, data);
      return response.data;
    } catch (error) {
      console.log('throw', error)
      throw error;
    }
  },
  update: async function (id, data) {
    try {
      const response = await ApiGateway.put(`/gateway/shipping/${id}`, data);
      return response.data;
    } catch (error) {
      console.log('throw', error)
      throw error;
    }
  },
  delete: async function (id) {
    try {
      const response = await ApiGateway.delete(`/gateway/shipping/${id}`);
      return response.data;
    } catch (error) {
      console.log('throw', error)
      throw error;
    }
  },
};

export default ShippingService;

export { ShippingService };

